import { OptionContent } from "@babackapp/customer-ui/components/option";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { CatalogProductCombobox } from "./catalog-product-combobox";
import type { CatalogProductItem } from "./catalog-product-combobox";

type Props = {
  shopId: string;
  selected: CatalogProductItem | null;
  onSelectedChange: (item: CatalogProductItem | null) => void;
};

export function CatalogSearchFooter({ shopId, selected, onSelectedChange }: Props) {
  const t = useCustomText();
  return (
    <OptionContent>
      <div className="w-full">
        <CatalogProductCombobox
          shopId={shopId}
          placeholder={t("catalogSearch.footerLabel")}
          selected={selected}
          onSelectedChange={onSelectedChange}
        />
      </div>
    </OptionContent>
  );
}
